import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=49458fe1&"
import script from "./CookieBanner.vue?vue&type=script&lang=js&"
export * from "./CookieBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports